<template>
  <div class="filter-icon-box">
    <i class="filter-icon" @click="onFilterIconClick"></i>
    <van-popup class="panel" v-model="isShowFilterSelected" position="right" :style="{ height: '100%', width: '80%' }">
      <div class="title">筛选</div>
      <van-collapse class="item-box" v-model="activeNames">
        <van-collapse-item class="item-list" v-for="it in filters" :key="it.text" :title="it.text" :name="it.text">
          <van-button
            :class="'item ' + (item.selected ? 'selected' : '')"
            v-for="item in it.data"
            :key="item.text"
            round
            @click="() => onClick(item)"
            >{{ item.text }}</van-button
          >
        </van-collapse-item>
      </van-collapse>
      <div class="fixed-submit">
        <van-button color="#999999" @click="reset" plain round>重置</van-button>
        <van-button color="#F09910" @click="search" round>
          确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Collapse, CollapseItem } from "vant";
import util from '../utils/util';

Vue.use(Collapse);
Vue.use(CollapseItem);

export default {
  computed: {
    selectedBrands() {
      return this.service.brandList.filter((it) => it.selected);
    },
    selectedCategorys() {
      return this.service.categoryList.filter((it) => it.selected);
    },
    categorys() {
      return this.service.categoryList;
    },
    brands() {
      //选中分类对品牌过滤
      if (this.selectedCategorys.length > 0) {
        return this.service.brandList.filter((it) => {
          let isShow = this.selectedCategorys.some((category) => it.categorySet.has(category.text));
          it.selected = it.selected && isShow;
          return isShow;
        });
      } else {
        return this.service.brandList;
      }
    },
    filters() {
      return [
        {
          text: "分类",
          name: "category",
          data: this.categorys,
        },
        {
          text: "品牌",
          name: "brand",
          data: this.brands,
        },
      ];
    },
  },
  props: {
    service: Object,
  },
  data() {
    return {
      activeNames: ["分类", "品牌"],
      isShowFilterSelected: false,
    };
  },
  created(){
    if(util.getSto('urlQuery')){
      let urlQuery = util.getStoObj('urlQuery');
      if(urlQuery.BrandId == "" && urlQuery.ProductClassifyId == ""){
        this.isShowFilterSelected = true;
      }
    }
  },
  methods: {
    onFilterIconClick() {
      this.isShowFilterSelected = true;
    },
    onClick(item) {
      item.selected = !item.selected;
    },
    search() {
      this.$emit("search", {
        categorys: this.selectedCategorys.map((it) => it.text),
        brands: this.selectedBrands.map((it) => it.text),
      });
      this.isShowFilterSelected = false;
    },
    reset() {
      // TODO: 重新开发重置功能
      this.categorys.forEach((it) => {
        it.selected = false;
      });
      this.brands.forEach((it) => {
        it.selected = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-icon-box {
  display: flex;
  align-items: center;
}
.filter-icon {
  background-image: url(../assets/shengji/filter.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 0.4rem;
  height: 0.4rem;
  margin: 0 0.3rem 0 0;
  vertical-align: text-top;
  display: inline-block;
}
.item-box {
  overflow: auto;
}
.panel {
  display: flex;
  flex-direction: column;
  .title {
    height: 0.83rem;
    line-height: 0.83rem;
    font-size: 0.36rem;
    font-weight: bold;
    color: rgba(65, 176, 53, 1);
    text-align: center;
  }
  .van-collapse {
    flex: 1;
    .item-list {
      .item {
        height: 0.6rem;
        width: 30%;
        margin-left: 3%;
        margin-bottom: 0.2rem;
        color: rgba(48, 52, 66, 1);
        background: rgba(245, 245, 250, 1);
        border-color: transparent;
        float: left;
        font-size: 12px;
      }
      .item.selected {
        background: rgba(79, 174, 84, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .fixed-submit {
    text-align: right;
    button {
      font-size: 0.3rem;
      width: 1.5rem;
      margin: 0.3rem;
    }
  }
}
</style>
<style lang="scss">
.item .van-button__content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
